import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  /**
   * Unique Key generator with Max length of 20
   */
  public static GetUniqueKey(): string {
    return "xxxxxxxxxxxxxxxxxxxx".replace(/[x]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return r.toString(16);
    });
  }

  /**
   * Merge defaults with user options
   * @param defaults Default settings
   * @param options User options
   * @returns Merged values of defaults and user options
   */
  public static extend(defaults: any, options: any): any {
    let extended = {};

    if (defaults) {

      for (var key in defaults) {
        if (defaults.hasOwnProperty(key)) {
          if (typeof defaults[key] === 'object')
            extended[key] = HelperService.extend(extended[key], defaults[key]);
          else
            extended[key] = defaults[key];
        }
      }
    }

    if (options) {

      for (var key in options) {
        if (options.hasOwnProperty(key)) {
          if (typeof options[key] === 'object')
            extended[key] = HelperService.extend(extended[key], options[key]);
          else
            extended[key] = options[key];
        }
      }
    }
    return extended;
  }

}

